import { type InputProps } from '../Input';
import { InputIcons } from './inputIcons';

export const inputUtils = {
  getDescr: ({ success, warning, error, description }: Partial<InputProps>) => {
    let descriptionElement: string | undefined;
    if (typeof success === 'string') descriptionElement = success;
    else if (typeof warning === 'string') descriptionElement = warning;
    else if (typeof error === 'string') descriptionElement = error;
    else if (description) descriptionElement = description;

    return descriptionElement;
  },
  getIcons: ({
    success,
    warning,
    error,
    readOnly,
    onReset,
    value,
    suffixIcon,
    prefixIcon,
    styles,
  }: Partial<InputProps> & { styles: Record<string, string> }) => {
    let statusIconElement: React.ReactNode = null;
    if (success) statusIconElement = <InputIcons.SuccessIcon />;
    if (warning) statusIconElement = <InputIcons.WarningIcon />;
    if (error) statusIconElement = <InputIcons.ErrorIcon />;

    const prefixIconElement: React.ReactNode = prefixIcon;

    let suffixIconElement: React.ReactNode = null;
    if (suffixIcon) suffixIconElement = suffixIcon;
    if (!readOnly && onReset && !suffixIcon && value) {
      suffixIconElement = (
        <InputIcons.ResetIcon
          onClick={onReset}
          style={{ cursor: 'pointer' }}
          data-test-id="input-reset-icon"
        />
      );
    }

    return (
      <>
        {prefixIconElement && (
          <span className={styles.prefixIcon} data-test-id="input-prefix-icon">
            {prefixIconElement}
          </span>
        )}
        {statusIconElement && (
          <span className={styles.statusIcon} data-test-id="input-status-icon">
            {statusIconElement}
          </span>
        )}
        {suffixIconElement && (
          <span className={styles.suffixIcon} data-test-id="input-suffix-icon">
            {suffixIconElement}
          </span>
        )}
      </>
    );
  },
};
